import CHAT_PUBLIC_FIELDS from './chatPublicFields';
import CHAT_MESSAGE_FIELDS from './chatMessageFields';

export default Object.values({ CHAT_PUBLIC_FIELDS, CHAT_MESSAGE_FIELDS });
export { CHAT_PUBLIC_FIELDS, CHAT_MESSAGE_FIELDS };
